window.SendOfferForm = function(scope, $filter, user, brandServices, onBoardingService, backgroundChecksService, positionsDataService, offerTemplatesService , $state, userServices, useOfferLetterFactory) {
    var self = this;
    var formName = "send-offer-form";
    var currency = '$';
    var _protected = BaseForm.call(self, formName, scope);
    self.onBoardingBrandSettings = {};
    var offerState, offerPreviewMetaData;

    var metaDatesFormat = "MMMM DD, YYYY";

    const offerLetterFactory = useOfferLetterFactory();
    const { FIELD_TYPES, FIELD_MODES, OFFER_TYPES } = offerLetterFactory;

    self.schema_data = [];
    self.originalFormSchema = null;
    self.originalCustomFormDynamicFields = [];
    self.schemaUpdateKey = 1;

    self.radissonSalaryTypes = [
        {
            name: 'Gross'
        },
        {
            name: 'Net'
        }
    ];

    const initializeCustomFieldsData = (schemaData) => {
        if (schemaData?.length > 0) {
            schemaData.forEach(field => {
                switch (field.type) {
                    case FIELD_TYPES.TEXT:
                    case FIELD_TYPES.NUMERIC:
                    case FIELD_TYPES.DROPDOWN:
                    case FIELD_TYPES.RADIO_BUTTON:
                        self.data[field.name] = self.data[field.name] || '';
                        break;
                    case FIELD_TYPES.DATE:
                        self.data[field.name] = self.data[field.name] || null;
                        break;
                    case FIELD_TYPES.CHECKBOX:
                        self.data[field.name] = false;
                        break;
                    case FIELD_TYPES.MULTI_SELECT:
                        if (self.data[field.name]?.length > 0) {
                            field.options.options.forEach(option => {
                                option.checked = self.data[field.name].includes(option.value);
                            });
                        } else {
                            self.data[field.name] = self.data[field.name] || [];
                            if (field?.options?.options) {
                                field.options.options.forEach(option => {
                                    option.checked = false;
                                });
                            }
                        }
                        break;
                }
            });
        }
    };

    var getATRById = function (ATRId) {
        self.atrs = self.atrs || [];
        return $filter('filter')(self.atrs, {'id': ATRId})[0];
    };

    var isATREnabled = function () {
        return self.atrEnabled;
    };

    var checkATRService = function (brandId) {
        var defer = $q.defer();

        brandServices.check(brandServices.SERVICES.ATR, brandId)
            .then(function (isATREnabled) {
                if (isATREnabled) {
                    ATRAPI.getBrandSettings(brandId)
                        .then(function (atrSettings) {
                            self.atrSettings = atrSettings;
                            // Don't handle ATR in offer in case of atr_type == MB
                            self.atrEnabled = (atrSettings.atr_type != "MB");
                            self.isOfferRestrictedFromAtrData = self.atrSettings.is_offer_data_restricted_from_atr_data;

                            if (self.atrSettings.atr_type === "BNB_WORKDAY") {
                                self.bnbAtrEnabled = self.atrSettings.positions.some(function (position) {
                                    return position.code === self.selected_position.code;
                                });
                                if (!self.bnbAtrEnabled) {
                                    self.atrEnabled = false;
                                    self.isOfferRestrictedFromAtrData = false;
                                }
                            } else if (self.atrSettings.atr_type === "EPS") {
                                self.epsAtrEnabled = true;
                            }
                            self.showAtrField = self.atrEnabled && (self.bnbAtrEnabled || self.epsAtrEnabled);
                            defer.resolve();
                        })
                        .catch(function (err) {
                            console.error(err);
                            defer.resolve();
                        });
                }
                else {
                    defer.resolve();
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject();
            });

        return defer.promise;
    };

    self.isATRValid = function (ATR) {
        return ['ATTACHED', 'AVAILABLE'].indexOf(ATR.status) > -1 || (ATR.status == "OFFERED" && ATR.id == self.savedATRId);
    };

    self.onATRChanged = function () {
        if (self.data.atr) {
            self.atr = getATRById(self.data.atr);

            self.data.hours_per_week = parseInt(self.atr.contract_hours);
            self.max_days_per_week = parseInt(self.atr.contract_days);
            self.data.job_type = self.atr.contract_type_id;

            if (self.selected_position) {
                self.selected_position = {
                    id: self.selected_position['id'],
                    code: self.selected_position['code'],
                    name: self.bnbAtrEnabled ? self.atr['job_posting_title'] : self.atr['job_title_name']
                };
            }

            if (self.isATRValid(self.atr)) {
                if (self.atrSettings && self.atrSettings.atr_type !== 'BNB_WORKDAY') {
                    var jobTypeField = $("select[name='job_type']");
                    var daysPerWeekField = $("input[name='days_per_week']");
                    var salaryField = $("input[name='salary']");

                    self.validator.validateSingleField(jobTypeField, null, true);
                    self.validator.validateSingleField(daysPerWeekField, null, true);
                    self.validator.validateSingleField(salaryField, null, true);
                } else if (self.isOfferRestrictedFromAtrData) {
                    self.data.job_type = self.atr['time_type'].toUpperCase();
                    self.maxRate = self.atr['base_salary_amount'];
                    self.max_days_per_week = parseInt(self.atr['contract_days']);

                    self.wagePlaceHolder = "Max. " + self.atr.base_salary_amount;
                    self.daysPlaceHolder = "Max. " + self.atr.contract_days;
                    self.hoursPlaceHolder = "Max. " + self.atr.scheduled_weekly_hours;

                    if (self.atr['base_salary_frequency'] === "Annual") {
                        self.data.compensation_rate = "PER_YEAR";
                    } else {
                        self.data.compensation_rate = "PER_HOUR";
                    }
                    self.onPayTypeChange();
                }

                if (self.epsAtrEnabled) {
                    if (self.data.job_type != 'C') {
                        self.wagePlaceHolder = "Max. " + self.atr.salary_rate;
                        self.daysPlaceHolder = "Max. " + self.atr.contract_days;
                        self.hoursPlaceHolder = "1 - " + self.atr.contract_hours;

                        self.minDays = 0;
                        self.minSalary = self.atrEnabled ? 1 : 0;

                        self.maxRate = self.atr.salary_rate;
                        self.data.compensation_rate = "PER_YEAR";

                        self.data.salary = "";
                        self.data.days_per_week = "";
                        self.data.hours_per_week = "";

                    } else {
                        self.data.compensation_rate = "PER_HOUR";
                        self.wagePlaceHolder = "";
                        self.daysPlaceHolder = "";

                        self.wagePlaceHolder = "Max. " + self.atr.salary_rate;
                        self.daysPlaceHolder = "Max. " + self.atr.contract_days;
                        self.hoursPlaceHolder = "1 - " + self.atr.contract_hours;

                        self.minSalary = self.atrEnabled ? 1 : 0;
                        self.maxRate = self.atr.salary_rate;

                        self.data.salary = self.atr.salary_rate;
                        self.data.days_per_week = 0;
                        self.max_days_per_week = 0;
                        self.data.hours_per_week = 0;
                        self.max_hours_per_week = 0;
                        self.minDays = 0;
                    }
                    self.onPayTypeChange();
                }
            }
            else {
                hAlert($filter("translate")("Can't select this ATR. Already consumed."));
            }

        }
    };

    self.onJobTypeChange = function () {
        if (self.atr && self.isATRValid(self.atr)) {
            if (self.atrSettings.atr_type === 'BNB_WORKDAY') {
                return;
            }
        }
        var hoursPerWeekField = $("input[name='hours_per_week']");
        self.validator.validateSingleField(hoursPerWeekField, null, true);
    };

    self.onPayTypeChange = async () => {
        if (self.isWageMatrixServiceEnabled && self.data?.compensation_rate && self.selected_position?.code && self.onBoardingBrandSettings?.offer_type !== 'RADISSON') {
            calculateWageMatrixDetails();
        }
        self.validator.validation = {};
    };

    self.jobTypeOptions = [];

    self.selected_position = null;
    self.lookups = {};
    self.load_template = {};
    self.data = {};
    self.OBIdObj = null;
    self.forceBrandIdValue = null;
    self.data.previewMetaData = null;
	self.isEditOfferEnabled = false;
	self.isEditOfferDescriptionEnabled = false;
    self.selected_template = null;
    self.validator.validation = {};
    self.formLoaded = false;

    let lastPositionCode = undefined;



    var formatWage = function(wage) {
        if (!isNaN(wage) ) {
            return parseFloat(wage).toFixed(2);
        }
    };

    var getBrandId = function() {
        if (self.forceBrandIdValue) {
            return self.forceBrandIdValue;
        }
        return self.OBIdObj.brand_id;
    };

    self.forceBrandId = function(brandId){
        self.forceBrandIdValue = brandId;
    };

    self.loadOfferTemplates = function(templates) {
        var defer = $q.defer();

        if (templates && templates.length == 1) {
            // If it is only one template, start selected
            self.load_template.template = templates[0];
        } else if (templates && templates.length > 1) {
            // If there is more than 1 template, select the most recent one which is the last one
            self.load_template.template = templates[templates.length - 1];
        } else {
            // If there is no templates && no PERMISSION, show alert modal to contact admin
            if ((!self.isEditOfferEnabled && (!templates || !templates.length))) {
                SettingsAPI.getBrandAdmins(self.OBIdObj.brand_id).then(function (admins) {
                    var user = _.findWhere(admins, {primary_user: true});
                    hAlert(
                        $filter("translate")("No Templates Available"),
                        $filter("translate")("Please contact "
                            + (user ? user.first_name + " " + user.last_name : "your primary admin")
                            + " to create a position offer template or grant you the needed access - there is no template associated with this position.")
                    );
                });
            }
        }

        defer.resolve(templates);

        return defer.promise;
    };

    self.initSaveOfferTemplateModal = function () {
        self.selected_template = self.selected_template || {};
        if (self.load_template && self.load_template.template) {
            self.selected_template.newName = self.load_template.template.name;
        } else {
            self.selected_template.newName = '';
        }
    };

    self.onTemplateChange = function () {
        self.schema_data = null;
        self.schemaUpdateKey++;
        scope.$digest();
        self.loadTemplate();
    };

    self.onPositionChange = async () => {
        if (self.selected_position.code === lastPositionCode) {
            return;
        }
        lastPositionCode = self.selected_position.code;

        self.loading = true;
        var payload = {
            'position_codes': [self.selected_position.code]
        };
        offerTemplatesService.getOfferTemplates(self.OBIdObj.brand_id, payload)
            .then(function (templates) {
                self.data.templates = templates;
                if (self.data.templates) {
                    let templateToUse = null;

                    if (self.load_template?.template?.id) {
                        templateToUse = self.data.templates.find(template => template.id === self.load_template.template.id);
                    }

                    if (!templateToUse) {
                        templateToUse = self.data.templates[self.data.templates.length - 1];
                    }

                    self.load_template.template = templateToUse;
                    self.load_template.position = self.selected_position;
                    self.loadTemplate();
                }
            })
            .catch(function (err) {
                console.error(err);
            })
            .finally(function () {
                self.loading = false;
            });

        if (self.isWageMatrixServiceEnabled && self.selected_position?.code && self.onBoardingBrandSettings?.offer_type !== 'RADISSON') {
            const wageRulesRes = await TeamAPI.getAllWageRules(self.OBIdObj.brand_id, self.selected_position?.code);
            self.allWageRules = wageRulesRes?.wage_rules;
            if (self.data?.compensation_rate) {
                calculateWageMatrixDetails();
            }
            scope.$digest();
        }
    }

    const calculateWageMatrixDetails = () => {
        self.effectiveWageRule = null;
        self.minWageRate = null;
        self.maxWageRate = null;
        if (self.allWageRules?.length > 0) {
            self.wageRules = onBoardingService.filterWageMatrixRules(self.allWageRules, self.data?.compensation_rate);
            self.appliedWageMatrixDetails = onBoardingService.getAppliedWageRulesDetails(self.birthDate, self.wageRules);
            self.effectiveWageRuleHasAgeRange = self.appliedWageMatrixDetails.effectiveWageRuleHasAgeRange;
            self.effectiveWageRule = self.appliedWageMatrixDetails.effectiveWageRule;
            self.minWageRate = self.appliedWageMatrixDetails.minWageRate;
            self.maxWageRate = self.appliedWageMatrixDetails.maxWageRate;
            self.data.salary = self.metaSalaryValue || self.templateSalaryValue || self.minWageRate;
            self.hasApplyRuleToNonZeroValues = self.effectiveWageRule?.apply_rule_to_non_zero_values;
        }
    }

    self.loadOfferFromFile = function(files) {

        if (files && files[0]) {

            var fileType = Utils.getFileType(files[0]);

            if ((fileType.indexOf("image/") > -1 && fileType.indexOf("image/gif") == -1) || fileType.indexOf("/pdf") > -1) {
                self.selectedFile = files[0];
            }
            else {
                hAlert($filter("translate")("Invalid file type") + ": " + files[0].name, $filter("translate")("Attachment should be image or PDF file."))
            }
        }
    };

    self.setUserPermissions = function(permissions) {
        self.isEditOfferEnabled = permissions.isEditOfferEnabled;
        self.isEditOfferDescriptionEnabled = permissions.isEditOfferDescriptionEnabled;
        self.hasManageBackgroundCheckSettings = permissions.hasManageBackgroundCheckSettings;
        self.canManageOfferTemplates = permissions.canManageOfferTemplates;
        self.canOverrideWageMatrix = permissions.canOverrideWageMatrix;
    };

    self.cannotChangeOfferPosition = function () {
        return self.hasOfferData && self.hasOfferData.id && (self.isTeamSchedulingEnabled || self.isCoreHRServiceEnabled) && self.isHiredProspect
    }

    self.load = function(OBIdObj, offerId, offerSource, offerFileName) {
        moment.locale("en");
        self.formLoaded = true;

        var initialPromises = {};
        var templatePromises = {};

        self.loading = true;
        self.OBIdObj = OBIdObj;
        self.selected_position = OBIdObj.positions[0];
        self.load_template.position = self.selected_position;
        self.offer_source = offerSource;
        self.offer_id = offerId;
        self.offer_file_name = offerFileName;
        self.atrs = [];

        self.wagePlaceHolder = "";
        self.maxRate = 999999999;
        self.daysPlaceHolder="";
        self.minDays = 0;
        self.isHiredProspect = false;

        self.wagePlaceHolder = "";
        self.hoursPlaceHolder = "";
        self.birthDate = self.OBIdObj?.birthdate && new Date(self.OBIdObj.birthdate);

        var prePromises = {};
        prePromises['currentBrandDetails'] = ProfileAPI.getBrandProfile(self.OBIdObj.brand_id)
        prePromises['isTeamSchedulingEnabled'] = brandServices.check(brandServices.SERVICES.TEAM_SCHEDULING, getBrandId());
        prePromises['isCoreHRServiceEnabled'] = brandServices.check(brandServices.SERVICES.CORE_HR, getBrandId());
        prePromises['isWageMatrixServiceEnabled'] = userServices.isServiceEnabled(userServices.SERVICES.WAGE_MATRIX, self.OBIdObj.brand_id);
        prePromises['onBoardingBrandSettings'] = onBoardingService.getOnboardingBrandSettings(self.OBIdObj.brand_id);
        $q.all(prePromises).then(function (preResult) {

        self.isTeamSchedulingEnabled = preResult['isTeamSchedulingEnabled'];
        self.isCoreHRServiceEnabled = preResult['isCoreHRServiceEnabled'];
        self.isWageMatrixServiceEnabled = preResult['isWageMatrixServiceEnabled'];
        self.onBoardingBrandSettings = preResult['onBoardingBrandSettings'];

        var payload = {
            'position_codes': [self.selected_position.code]
        };
        initialPromises['templates'] = offerTemplatesService.getOfferTemplates(self.OBIdObj.brand_id, payload);
        initialPromises['atr_service'] = checkATRService(self.OBIdObj.brand_id);
        initialPromises['brand_locations'] = BrandAPI.getBrandPublicLocations(self.OBIdObj.brand_id);
        initialPromises['onboarding_settings'] = onBoardingService.init(self.OBIdObj.brand_id);
        initialPromises['background_check_service_enabled'] = brandServices.check(brandServices.SERVICES.BACKGROUND_CHECK, self.OBIdObj.brand_id);
        initialPromises['background_check_service_enabled'] = brandServices.check(brandServices.SERVICES.BACKGROUND_CHECK, self.OBIdObj.brand_id);
        initialPromises['auto_load_offer_template_enabled'] = brandServices.check(brandServices.SERVICES.AUTO_LOAD_OFFER_TEMPLATE, getBrandId());
        initialPromises['positions'] = positionsDataService.getActivePositionsFlat(false, getBrandId())
        initialPromises['parent_brand'] = ProfileAPI.getBrandProfile(preResult['currentBrandDetails'].group_id);
        initialPromises['offerData'] = OnBoardingAPI.getApplicationDocumentLastMeta(self.OBIdObj.brand_id, 'OFFER', self.OBIdObj.prospect_id, self.OBIdObj.app_id);
        initialPromises['hiredProspects'] = OnBoardingAPI.getProspectsByUserIds(self.OBIdObj.brand_id, [self.OBIdObj.candidate_id], ['HIRED'], false);
        if (self.isTeamSchedulingEnabled || self.isCoreHRServiceEnabled) {
            initialPromises['coreHREmployeeAwareness'] = TeamAPI.getCoreHREmployeeAwareness(self.OBIdObj.brand_id, self.OBIdObj.candidate_id)
        }

        if (self.isWageMatrixServiceEnabled && self.selected_position?.code && self.onBoardingBrandSettings?.offer_type !== 'RADISSON') {
            initialPromises['wageRules'] = TeamAPI.getAllWageRules(self.OBIdObj.brand_id, self.selected_position?.code);
        }

        $q.all(initialPromises)
            .then(function (result) {

                self.lookups.positions = result['positions'];
                self.data.templates = result['templates'];
                var locations = result['brand_locations'];
                currency = Utils.locationCurrencySymbol({Location: locations});
                var isAutoLoadTemplateEnabled = result['auto_load_offer_template_enabled'];

                self.hasOfferData = result['offerData'];
                self.isBackgroundCheckServiceEnabled = result['background_check_service_enabled'];
                if (self.isTeamSchedulingEnabled || self.isCoreHRServiceEnabled) {
                    if (self.OBIdObj) {
                        self.OBIdObj.coreHREmployeeDetails = result['coreHREmployeeAwareness'].user;
                    }
                }
                self.allWageRules = result['wageRules']?.wage_rules;

                var hiredProspectIds = [];
                if (result['hiredProspects'][0] && result['hiredProspects'][0].prospects && result['hiredProspects'][0].prospects.length) {
                    hiredProspectIds = _.pluck(result['hiredProspects'][0].prospects, 'id');
                }
                self.isHiredProspect = hiredProspectIds.indexOf(self.OBIdObj?.prospect_id) > -1

                if (self.hasOfferData && self.hasOfferData.id && self.cannotChangeOfferPosition()) {
                    self.selected_position = _.find(self.lookups.positions,function(pos) {
                        return pos.code === self.hasOfferData.meta_data.position_code
                    });
                }

                offerTemplatesService.getSmartFields(self.onBoardingBrandSettings.offer_type)
                    .then(function (res) {
                        self.smartFields = res;
                        addCustomFieldsToSmartFields();
                    })
                    .catch(function (err) {
                        console.error(err);
                    });

                if (self.atrSettings && self.atrSettings.atr_type === "BNB_WORKDAY") {
                    self.jobTypeOptions = [
                        {value: "FULL_TIME", label: $filter("translate")("Full Time")},
                        {value: "PART_TIME", label: $filter("translate")("Part Time")}
                    ];

                    if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
                        self.compensationRate = [
                            {value: "PER_HOUR", label: $filter("translate")("Hour")},
                            {value: "PER_MONTH", label: $filter("translate")("Month")},
                            {value: "PER_YEAR", label: $filter("translate")("Year")}
                        ];
                    } else {
                        self.compensationRate = [
                            {value: "PER_HOUR", label: $filter("translate")("Hour")},
                            {value: "PER_YEAR", label: $filter("translate")("Year")}
                        ];
                    }

                    self.jobTypeMappings = {
                        "Full_time": $filter("translate")("Full time"),
                        "Part_time": $filter("translate")("Part time")
                    };
                } else if (isATREnabled()) {
                    if (self.atrSettings.atr_type === "EPS") {
                        self.jobTypeOptions = [
                            {value: "C", label: $filter("translate")("Zero Hours")},
                            {value: "P", label: $filter("translate")("Permanent")},
                            {value: "S", label: $filter("translate")("Fixed Term")}
                        ];

                        self.compensationRate = [
                            {value: "PER_HOUR", label: $filter("translate")("Hour")},
                            {value: "PER_WEEK", label: $filter("translate")("Week")},
                            {value: "PER_MONTH", label: $filter("translate")("Month")},
                            {value: "PER_YEAR", label: $filter("translate")("Year")}
                        ];

                    }
                } else {

                    self.jobTypeOptions = [
                        {value: "FULL_TIME", label: $filter("translate")("Full Time")},
                        {value: "PART_TIME", label: $filter("translate")("Part Time")},
                        {value: "SEASONAL", label: $filter("translate")("Seasonal")},
                        {value: "HOURS_VARIABLE_OR_FLEXIBLE", label: $filter("translate")("Hours Variable/Flexible")}
                    ];

                    if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
                        self.compensationRate = [
                            {value: "PER_HOUR", label: $filter("translate")("Hour")},
                            {value: "PER_MONTH", label: $filter("translate")("Month")},
                            {value: "PER_YEAR", label: $filter("translate")("Year")}
                        ];
                    } else {
                        self.compensationRate = [
                            {value: "PER_HOUR", label: $filter("translate")("Hour")},
                            {value: "PER_WEEK", label: $filter("translate")("Week")},
                            {value: "PER_MONTH", label: $filter("translate")("Month")},
                            {value: "PER_YEAR", label: $filter("translate")("Year")}
                        ];
                    }
                }

                var promises = {};

                self.brands = [];

                if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
                    promises['radisson_countries'] = $http.get("../modules/hforms/candidate_onboarding/scripts/constants/radisson_countries.json");
                    promises['radisson_currencies'] = $http.get("../modules/hforms/send_offer/scripts/constants/currencies.json");

                    var brandsList = user.data.user.brands_list;
                    var currentBrand = preResult['currentBrandDetails'];

                    if (currentBrand) {
                        if (currentBrand.type === 'child') {
                            var brandParent = _.findWhere(brandsList, {id: currentBrand.group_id});

                            if (brandParent) {
                                self.brands.push({name: brandParent.name, id: brandParent.id});
                            } else if (result['parent_brand'] && result['parent_brand'].type === 'enterprise') {
                                brandParent = result['parent_brand'];
                                self.brands.push({name: brandParent.name, id: brandParent.id});
                            }

                        } else {
                            self.brands.push({name: currentBrand.name, id: currentBrand.id});
                        }
                    }

                    self.brands.push({name: 'Other', id: null});
                }

                promises['user_details'] = UserAPI.getUserBasicDetails(OBIdObj.candidate_id);

                if (self.isBackgroundCheckServiceEnabled && self.hasManageBackgroundCheckSettings) {
                    promises['position_package_mappings'] = backgroundChecksService.getPositionPackageMappings(self.OBIdObj?.brand_id);
                }


                $q.all(promises)
                    .then(function(res) {

                        if (res['radisson_countries']) {
                            self.radissonCountries =  _.map(res['radisson_countries'].data || [], function (country) {
                                return {name: country.EnglishName, code: country.Code}
                            });
                        }

                        if (res['radisson_currencies']) {
                            self.radissonCurrencies = res['radisson_currencies'].data;
                        }

                        if (self.isBackgroundCheckServiceEnabled && self.hasManageBackgroundCheckSettings) {
                            self.automativeInviteAfterOffer = res['position_package_mappings'].automatic_invite_after_offer;
                        }

                        self.data.candidate = res['user_details'];

                        var offerStatusPromises = {};

                        if (offerId && offerSource != 'UPLOADED') {
                            offerStatusPromises['offer_state'] = OnBoardingAPI.getOnboardingUserDocuments({document_id : offerId, meta_data : true})
                                .then(function (data) {
                                    self.savedATRId = null;
                                    if (isATREnabled()) {
                                        getATRs().then(function () {
                                            if (offerId) {
                                                ATRAPI.getOfferATR(OBIdObj.brand_id, offerId)
                                                    .then(function (ATR) {
                                                        if (!self.OBIdObj?.job_id) {
                                                            self.atrs.push(ATR)
                                                        }
                                                        if (ATR && ATR.id) {
                                                            self.savedATRId = ATR.id;
                                                            self.data.atr = ATR.id.toString();
                                                            self.atr = getATRById(self.data.atr);
                                                            scope.$digest();
                                                        }
                                                    });
                                            }
                                        });
                                    } else {
                                        delete self.loading;
                                    }
                                    offerPreviewMetaData = data[0].document.meta_data || {};
                                    offerState = data[0].document.state;

                                    prefillOfferFromMeta(offerPreviewMetaData);

                                    scope.$digest();
                                }, function (err) {
                                    delete self.loading;
                                    console.error(err);
                                });
                        } else {
                            offerState = null;
                            self.data.salary = "";
                            self.data.compensation_rate = "";
                            self.data.offer_details = {offer_details : ""};
                            self.data.supervisor_name = user.data.user.name;
                            self.selected_position = {
                                'name': self.selected_position.name,
                                'code': self.selected_position.code,
                                'id': self.selected_position.id
                            };

                            var defaultDefer = $q.defer();
                            templatePromises['default_template'] = defaultDefer.promise;

                            offerTemplatesService.loadDefaultDetails(OBIdObj.brand_id, false, self.selected_position.id)
                                .then((function(details) {
                                    if (isATREnabled()) {
                                        getATRs();
                                    } else {
                                        delete self.loading;
                                    }

                                    if (self.onBoardingBrandSettings.offer_type !== 'RADISSON' && !(self.atrSettings && self.atrSettings.atr_type === "BNB_WORKDAY")) {
                                        self.data.compensation_rate = "PER_HOUR";
                                        self.onPayTypeChange();
                                    }

                                    self.data.offer_details = $.extend(self.data.offer_details, details);
                                    self.data.offer_details.offer_details = self.data.offer_details.offer_details.replace(/\$/g, currency);
                                    self.data.supervisor_title = self.data.supervisor_title || details.supervisor_title;

                                    defaultDefer.resolve(details);
                                }))
                                .catch(function (err) {
                                    console.error(err);
                                    defaultDefer.reject(err);
                                });
                        }

                        $q.all(offerStatusPromises).then(function () {
                            if ((!self.offer_id || offerState === "SIGNED")) {
                                var templatesDefer = $q.defer();
                                templatePromises['templates'] = templatesDefer.promise;
                                if (isAutoLoadTemplateEnabled) {
                                    self.loadOfferTemplates(self.data.templates)
                                        .then(function (templates) {
                                            templatesDefer.resolve(templates);
                                        });
                                } else {
                                    if (!self.isTemplatePrefilledFromMeta) {
                                        self.load_template.template = self.data.templates[self.data.templates.length - 1];
                                    }
                                    templatesDefer.resolve(self.data.templates);
                                }
                            }

                            $q.all(templatePromises).then(function (data) {
                                if (data.templates && data.templates.length) {
                                    self.loadTemplate();
                                } else if (data.default_template) {
                                    var details = data.default_template;

                                if (self.onBoardingBrandSettings.offer_type !== 'RADISSON' && !(self.atrSettings && self.atrSettings.atr_type === "BNB_WORKDAY")) {
                                    self.data.compensation_rate = "PER_HOUR";
                                    self.onPayTypeChange();
                                }

                                    self.data.offer_details = details;
                                    self.data.supervisor_title = self.data.supervisor_title || details.supervisor_title;
                                }

                                scope.$digest();
                            });
                        });
                    });
            })
            .catch(function (err) {
                console.error(err);

                hAlert(
                    $filter("translate")("Something Went Wrong"),
                    $filter("translate")("Error preparing send offer form")
                );
            });
            });

    };

    var prefillOfferFromMeta = function (previewMetaData) {
        // prefill from last_meta if the document not signed (edit mode), or
        //  auto load offer service not enabled
        self.isTemplatePrefilledFromMeta = false;
        if (previewMetaData.offer_template_id) {
            self.load_template.template = self.data.templates.find(template => template.id === previewMetaData.offer_template_id);
            self.isTemplatePrefilledFromMeta = true;
        }
        const metaSalary = previewMetaData.salary && formatWage(previewMetaData.salary);
        self.data.salary = metaSalary;
        self.metaSalaryValue = metaSalary;
        self.data.salary_loaded = self.data.salary;
        self.data.salary_type = previewMetaData.salary_type;
        self.data.salary_from = previewMetaData.salary_from;
        self.data.salary_to = previewMetaData.salary_to;

        self.data.offer_details = {offer_details : previewMetaData.offer_details};
        self.data.job_type = previewMetaData.job_type;
        self.data.hours_per_week = previewMetaData.hours_per_week;
        self.data.days_per_week = previewMetaData.days_per_week;
        self.data.supervisor_title = previewMetaData.supervisor_title || self.data.supervisor_title;

        if (previewMetaData.start_date) {
            self.data.start_date = moment(previewMetaData.start_date, metaDatesFormat, "en", true).locale(moment.locale());
        }
        if (previewMetaData.first_pay_date) {
            self.data.first_pay_date = moment(previewMetaData.first_pay_date, metaDatesFormat, "en", true).locale(moment.locale());
        }
        if (previewMetaData.expiry_date) {
            self.data.expiry_date = moment(previewMetaData.expiry_date, metaDatesFormat, "en", true).locale(moment.locale());
        }

        if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
            if (previewMetaData.country) {
                self.data.radissonCountry = _.findWhere(self.radissonCountries, { name: previewMetaData.country});
            }

            if (previewMetaData.currency) {
                self.data.radissonCurrency = _.findWhere(self.radissonCurrencies, { code: previewMetaData.currency});
            }

            if (previewMetaData.gross_net) {
                self.data.radissonSalaryType = _.findWhere(self.radissonSalaryTypes, { name: previewMetaData.gross_net});
            }

            if (previewMetaData.unit_name) {
                self.data.radissonUnitName = _.findWhere(self.brands, { name: previewMetaData.unit_name});

                if (!self.data.radissonUnitName) {
                    self.data.radissonUnitName = _.findWhere(self.brands, { name: 'Other'});
                    self.data.other_radisson_unit_name = previewMetaData.unit_name;
                }
            }

            if (previewMetaData.compensation === 'PER_HOUR' || previewMetaData.compensation === 'PER_YEAR') {
                self.data.compensation_rate = previewMetaData.compensation;
                self.onPayTypeChange();
            } else {
                delete self.data.compensation_rate;
            }

        } else {
            self.data.supervisor_name = previewMetaData.supervisor_name || user.data.user.name;
            self.data.compensation_rate = previewMetaData.compensation;
            self.onPayTypeChange();
        }

        self.data.offer_template_id = previewMetaData.offer_template_id;

        if (self.data.offer_template_id) {
            var selectedTemplate = self.data.templates.filter(function (template) {
                return template.id == self.data.offer_template_id;
            });

            self.data.salary_type = selectedTemplate[0] && selectedTemplate[0].salary_type;
            self.data.salary_from = selectedTemplate[0] && selectedTemplate[0].salary_from;
            self.data.salary_to = selectedTemplate[0] && selectedTemplate[0].salary_to;
        }
        self.selected_position = {
            'name': previewMetaData.position_name,
            'code': previewMetaData.position_code,
            'id': previewMetaData.position_id
        };

        if (self.load_template?.template?.form_schema?.employer_form) {
            self.schema_data = self.load_template.template.form_schema.employer_form;
            self.schemaUpdateKey++;
            addCustomFieldsToSmartFields();
        }

        if (self.schema_data?.length > 0) {
            self.schema_data.forEach(field => {
                if (previewMetaData.hasOwnProperty(field.name)) {
                    switch (field.type) {
                        case FIELD_TYPES.DATE:
                            if (previewMetaData[field.name]) {
                                self.data[field.name] = new Date(previewMetaData[field.name]);
                            }
                            break;
                        case FIELD_TYPES.MULTI_SELECT:
                            if (field?.options?.options && previewMetaData[field.name]) {
                                const selectedValues = Array.isArray(previewMetaData[field.name]) 
                                    ? previewMetaData[field.name] 
                                    : [previewMetaData[field.name]];
                                
                                field.options.options.forEach(option => {
                                    option.checked = selectedValues.includes(option.value);
                                });
                                self.data[field.name] = selectedValues;
                            }
                            break;
                        case FIELD_TYPES.CHECKBOX:
                            self.data[field.name] = Boolean(previewMetaData[field.name]);
                            break;
                        case FIELD_TYPES.TEXT:
                        case FIELD_TYPES.NUMERIC:
                        case FIELD_TYPES.DROPDOWN:
                        case FIELD_TYPES.RADIO_BUTTON:
                        default:
                            self.data[field.name] = previewMetaData[field.name];
                            break;
                    }
                }
            });
        }
    };

    self.canEditOfferSalary = function () {
        if (!self.isEditOfferEnabled && self.data.salary_type !== 'RANGE' && (!self.load_template?.template || self.data.salary_loaded)) {
            return true;
        }
    }

    self.sendOffer = function () {
        var defer = $q.defer();

        var prospect = {
            "user_id": self.OBIdObj.candidate_id,
            "brand_id": self.OBIdObj.brand_id,
            "job_id": self.OBIdObj.job_id,
            "position_id": self.OBIdObj.positions[0].id,
            "application_id": self.OBIdObj.app_id,
            "prospect_id": self.OBIdObj.prospect_id,
        };

        // Capitalize the first letter in user last name
        var lastName = self.data.candidate.last_name;
        lastName = lastName[0].toUpperCase() + lastName.slice(1);

        var documents = [{
            "code": OnBoardingAPI.DOCUMENT_TYPE.OFFER,
            "atr_id": self.data.atr,
            "metadata": self.getOfferData(true),

        }];

        if (self.selected_template && !documents[0]['metadata'].offer_template_id) {
            documents[0]['metadata'].offer_template_id = self.selected_template.id;
        }


        self.isUploading = true;
        onBoardingService.sendDocuments(prospect, documents, null, null, null, self.data.is_internal_employee)
            .then(function (result) {
                if (result.sent && result.sent.length) {
                    defer.resolve(result);
                }
                else {
                    defer.reject(result);
                }
            })
            .catch(function (err) {
                if (err.data.status_code === 403) {
                    hAlert($filter("translate")("No Permission"), $filter("translate")("You have no permission to edit this offer."));
                }
                console.error(err);
                defer.reject(err);
            })
            .finally(function () {
                self.isUploading = false;
            });

        return defer.promise;
    };

    var updateATRs = function(atrs, wantedStatus) {
        self.atrs = atrs;
        if (self.atrs.length == 1 && self.atrs[0].status === wantedStatus) {
            self.data.atr = self.atrs[0].id.toString();
            self.onATRChanged();
        }
        delete self.loading;
        scope.$digest();
    };

    var getATRs = function() {
        var defer = $q.defer();

        if (self.OBIdObj.job_id) {
            if (!self.OBIdObj.atrs) {
                ATRAPI.getJobATR(self.OBIdObj.brand_id, self.OBIdObj.job_id)
                    .then(function (res) {
                        updateATRs(res.atrs, "ATTACHED");
                        defer.resolve(self.atrs);
                    });
            } else {
                updateATRs(res.atrs, "ATTACHED");
                defer.resolve(self.atrs);

            }
        }
        else {

            ATRAPI.getPositionATR(self.OBIdObj.brand_id, self.OBIdObj.positions[0].code)
                .then(function (res) {
                    updateATRs(res.atrs, "AVAILABLE");
                    defer.resolve(self.atrs);
                });

        }

        return defer.promise;
    };

    self.getWageMatrixValidationMessage = () => {
        if (self.maxWageRate) {
            return`${$filter("translate")("Wage/Salary should be between")} ${self.minWageRate} ${$filter("translate")("and")} ${self.maxWageRate}`;
        } else if (self.minWageRate) {
            return`${$filter("translate")("Wage/Salary should be")} ${self.minWageRate}`;
        }
    }

    self.validator.validateCustom = function (field, optionsField, rule, showError) {
        var value = self.validator.getFieldValue(field);

        switch (rule.name) {
            case 'salary-min':
                value = parseFloat(value);
                self.minSalary = self.epsAtrEnabled ? 1 : 0;

                if (value < self.minSalary) {
                    return false;
                }

                break;

            case 'salary-max':
                value = parseFloat(value);

                if ((self.atrEnabled && self.isOfferRestrictedFromAtrData) && self.atr) {
                    self.maxRate = self.atr['base_salary_amount'];
                    return (value <= self.atr['base_salary_amount']);
                }

                break;

            case 'salary-out-of-range':
                if (!self.isEditOfferEnabled) {
                    if (self.data.salary_type == "RANGE" && (value < self.data.salary_from || value > self.data.salary_to)) {
                        return false;
                    }
                }
                break;

            case 'contract-days-min':
                value = parseFloat(value);

                if (self.atr && (value < self.minDays)) {
                    return false;
                }

                break;


            case 'contract-days-max':
                value = parseFloat(value);

                if (self.atr && (self.atr.contract_days || self.atr.contract_days === 0)) {
                    self.max_days_per_week = parseInt(self.atr.contract_days);
                    return (value <= self.max_days_per_week);
                }

                break;

            case 'required-if-visible':

                if ($("#" + rule.params[0]).is(":visible") && !value) {
                    return false;
                }

                break;
            case "required-if-not-hours-variable":

                if (!self.isWorkHoursInputDisabled() && !self.isOfferRestrictedFromAtrData) {
                    if (self.data['job_type'] && self.data['job_type'] !== "HOURS_VARIABLE_OR_FLEXIBLE" && isNaN(parseFloat(self.data.hours_per_week))) {
                        return false;
                    }
                }

                if ((self.atrEnabled && self.isOfferRestrictedFromAtrData) && (!(self.data.hours_per_week) && (self.data.hours_per_week !== 0))) {
                    return false;
                }

                break;
            case 'wage-matrix-required-birthdate':
                if (self.isWageMatrixServiceEnabled && self.effectiveWageRuleHasAgeRange && !self.birthDate && (self.data.compensation_rate === 'PER_HOUR' || self.data.compensation_rate === 'PER_YEAR')) {
                    return false;
                }
                return true;
                break
            case 'is-valid-wage-matrix-salary':
                if (self.effectiveWageRuleHasAgeRange && !self.birthDate) {
                    return true;
                }

                if (self.isWageMatrixServiceEnabled && self.wageRules &&
                    (self.data.compensation_rate === 'PER_HOUR' || self.data.compensation_rate === 'PER_YEAR')) {
                    if (!self.effectiveWageRule) {
                        return true;
                    }
                    if (self.hasApplyRuleToNonZeroValues && parseFloat(self.data.salary) === 0) {
                        return true;
                    }

                    let isSalaryValid = true;
                    if (self.canOverrideWageMatrix) {
                        if (self.data.salary < self.minWageRate) {
                            isSalaryValid = false;
                        }
                    } else {
                         isSalaryValid = self.maxWageRate ? (self.data.salary >= self.minWageRate && self.data.salary <= self.maxWageRate) : (parseFloat(self.data.salary) === self.minWageRate);
                    }
                    return !!isSalaryValid;
                }
                return true;
                break
            case 'custom_required':
                if (self.data) {
                    const fieldName = $(field).attr('name');
                    const selectedValues = self.data[fieldName];
                    if (!selectedValues || selectedValues.length === 0) {
                        return false;
                    }
                }
                break;
        }

        return true;
    };

    self.checkedOption = (field) => {
        let optionsValues = [];
        if (field?.options?.options) {
            field.options.options.forEach(option => {
                if (option.checked) {
                    optionsValues.push(option.value);
                }
            });
        }
        self.data[field.name] = optionsValues;
    };

    self.getCustomFieldsData = () => {
        return {
            form_schema: self.originalFormSchema || { employer_form: [] },
            custom_form_dynamic_fields: self.originalCustomFormDynamicFields || []
        };
    };

    const addCustomFieldsToSmartFields = () => {
        const currentFields = self.smartFields?.filter(sf => sf.source !== 'custom') || [];
        const customSmartFields = self.schema_data?.map(field => offerLetterFactory.convertToSmartField(field)) || [];
        const existingIds = (currentFields).map(sf => sf.id);
        const newCustomFields = customSmartFields.filter(csf => !existingIds.includes(csf.id));
        if (newCustomFields.length > 0) {
            self.smartFields = [...currentFields, ...newCustomFields];
        }
    }

    self.loadTemplate = async () => {
        if (self.load_template.template && self.load_template.position) {
            self.selected_template = self.load_template.template;
            self.selected_position = self.load_template.position;
            const templateSalary = self.load_template?.template?.salary && formatWage(self.load_template.template.salary);
            self.data.salary = templateSalary
            self.templateSalaryValue = templateSalary;
            self.data.salary_loaded = self.data.salary;
            self.data.salary_from = self.load_template.template.salary_from;
            self.data.salary_to = self.load_template.template.salary_to;
            self.data.salary_type = self.load_template.template.salary_type;

            self.load_template.template.details = self.load_template.template.details || "";
            self.data.offer_details = {offer_details: self.load_template.template.details.replace(/\$/g, currency)};

            self.data.job_type = self.load_template.template.job_type;
            self.data.hours_per_week = self.load_template.template.hours_per_week;
            self.data.days_per_week = self.load_template.template.days_per_week;

            self.data.supervisor_title = self.load_template.template.supervisor_title;
            if (self.load_template.template.start_date) {
                self.data.start_date = moment(self.load_template.template.start_date, metaDatesFormat, "en", true).locale(moment.locale());
            }
            if (self.load_template.template.first_pay_date) {
                self.data.first_pay_date = moment(self.load_template.template.first_pay_date, metaDatesFormat, "en", true).locale(moment.locale());
            }
            if (self.load_template.template.expiry_date) {
                self.data.expiry_date = moment(self.load_template.template.expiry_date, metaDatesFormat, "en", true).locale(moment.locale());
            }

            if (self.load_template?.template?.form_schema?.employer_form) {
                self.schema_data = self.load_template.template.form_schema.employer_form;
                self.schemaUpdateKey++;
                addCustomFieldsToSmartFields();
                self.originalFormSchema = self.load_template.template.form_schema;
                self.originalCustomFormDynamicFields = self.load_template.template.custom_form_dynamic_fields || [];
                initializeCustomFieldsData(self.schema_data);
            } else {
                self.schema_data = [];
                self.schemaUpdateKey++;
                self.originalFormSchema = null;
                self.originalCustomFormDynamicFields = [];
            }

            if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
                if (self.load_template.template.country) {
                    self.data.radissonCountry = _.findWhere(self.radissonCountries, { name: self.load_template.template.country});
                }

                if (self.load_template.template.currency) {
                    self.data.radissonCurrency = _.findWhere(self.radissonCurrencies, { code: self.load_template.template.currency});
                }

                if (self.load_template.template.gross_net) {
                    self.data.radissonSalaryType = _.findWhere(self.radissonSalaryTypes, { name: self.load_template.template.gross_net});
                }

                if (self.load_template.template.unit_name) {
                    self.data.radissonUnitName = _.findWhere(self.brands, { name: self.load_template.template.unit_name});

                    if (!self.data.radissonUnitName) {
                        self.data.radissonUnitName = _.findWhere(self.brands, { name: 'Other'});
                        self.data.other_radisson_unit_name = self.load_template.template.unit_name;
                    }
                }

                if (
                    self.load_template.template.compensation_rate === 'PER_HOUR' ||
                    self.load_template.template.compensation_rate === 'PER_YEAR'
                ) {
                    self.data.compensation_rate = self.load_template.template.compensation_rate;
                } else {
                    delete self.data.compensation_rate;
                }

            } else {
                self.data.supervisor_name = self.load_template.template.supervisor_name;
                self.data.compensation_rate = self.load_template.template.compensation_rate;
            }

            if (self.isWageMatrixServiceEnabled && self.selected_position?.code && self.onBoardingBrandSettings?.offer_type !== 'RADISSON') {
                const wageRulesRes = await TeamAPI.getAllWageRules(self.OBIdObj.brand_id, self.selected_position?.code);
                self.allWageRules = wageRulesRes?.wage_rules;
                if (self.data?.compensation_rate) {
                    calculateWageMatrixDetails();
                }
                scope.$digest();
            }

            delete self.data.atr;
            self.validator.validation = {};
            scope.$digest();
        }
    };

    self.saveTemplate = async (update) => {
        var defer = $q.defer();
        var offerTemplateNameField = $("input[name='offer_template']");
        var valid = self.validator.validateSingleField(offerTemplateNameField, null, true);

        try {
            if (self.selected_template?.newName) {
                const excludeTemplateId = update ? (self.load_template?.template?.id || self.data.offer_template_id) : null;
                const isAvailable = await offerLetterFactory.checkUniqueOfferTemplateName(self.OBIdObj.brand_id, self.selected_template.newName, excludeTemplateId);
                self.isDuplicateOfferTemplateName = !isAvailable;
            } else {
                self.isDuplicateOfferTemplateName = false;
            }
        } catch (error) {
            console.error('Error checking template name uniqueness:', error);
            self.isDuplicateOfferTemplateName = false;
        }

        if (valid && !self.isDuplicateOfferTemplateName) {
            if (self.selected_position && self.selected_position.id) {

                var saveTemplateAction = function(offerTemplate) {
                    var promise;
                    if (offerTemplate.id && update) {
                        promise = offerTemplatesService.editOfferTemplate(self.OBIdObj.brand_id, offerTemplate.id, offerTemplate)
                    } else {
                        promise = offerTemplatesService.addOfferTemplate(self.OBIdObj.brand_id, offerTemplate)
                    }

                    promise
                        .then(function(newTemplate) {
                            if (offerTemplate.custom_form_dynamic_fields) {
                                newTemplate.form_schema = offerTemplate.form_schema;
                                newTemplate.custom_form_dynamic_fields = offerTemplate.custom_form_dynamic_fields;
                            }
                            self.load_template.template = newTemplate;
                            self.load_template.position = self.selected_position;
                            self.loadTemplate();
                            self.data.templates.push(self.load_template.template);
                            defer.resolve();
                        })
                        .catch(function(err) {
                            self.loadTemplate();
                            console.error(err);
                            defer.reject(err);
                        });
                };

                var positions = [];
                var categories = [];
                if (self.load_template && self.load_template.template) {
                    positions = self.load_template.template.positions || [];
                    categories = self.load_template.template.categories || [];
                }

                var offerTemplate = {
                    name: self.selected_template.newName,
                    positions: positions,
                    categories: categories,
                    salary: self.data.salary && formatWage(self.data.salary),
                    compensation_rate: self.data['compensation_rate'],
                    details : self.data.offer_details.offer_details.replace(/\$/g, currency),
                    job_type: self.data['job_type'],
                    days_per_week: self.data['days_per_week'],
                    supervisor_title: self.data['supervisor_title'],
                    supervisor_name: self.data['supervisor_name'],
                    hours_per_week: self.data['hours_per_week'],
                    currency: self.data.radissonCurrency && self.data.radissonCurrency.code,
                    gross_net: self.data['gross_net'] && self.data['gross_net'].name,
                    country: self.data.radissonCountry && self.data.radissonCountry.name,
                    unit_name: (self.data['unit_name'] && self.data['unit_name'].id) ? self.data['unit_name'].name : self.data['other_unit_name'],
                };

                const customFieldsData = self.getCustomFieldsData();
                if (customFieldsData.form_schema.employer_form.length > 0) {
                    offerTemplate.form_schema = customFieldsData.form_schema;
                    offerTemplate.custom_form_dynamic_fields = customFieldsData.custom_form_dynamic_fields;
                }

                if (self.selected_template.id && update) {
                    offerTemplate.id = self.selected_template.id;
                    offerTemplate.brands = self.data.brands;
                    if (self.selected_template.newName !== self.selected_template.name) {
                        hConfirm($filter("translate")("Are you sure you want to overwrite template") + " \"" + self.selected_template.name + "\"?", function(confirm){
                            if (confirm) {
                                offerTemplate.name = self.selected_template.newName;
                                saveTemplateAction(offerTemplate);
                            } else {
                                defer.reject();
                            }
                        });
                    } else {
                        saveTemplateAction(offerTemplate);
                    }
                } else {
                    positions.push({
                        code: self.selected_position.code
                    });
                    offerTemplate['positions'] = positions;
                    offerTemplate.brands = [{id: self.OBIdObj.brand_id}];
                    saveTemplateAction(offerTemplate);
                }
            } else {
                self.sendOfferForm.validator.validation['position_id'] = { errors: {'required': true}};
                defer.reject({});
            }
        } else {
            defer.reject();
        }

        return defer.promise;
    };

    //get Preview Data
    self.getOfferData = function () {
        // Capitalize the first letter in user last name
        var lastName = self.data.candidate.last_name;
        lastName = lastName[0].toUpperCase() + lastName.slice(1);

        var firstName = self.data.candidate.first_name;
        firstName = firstName[0].toUpperCase() + firstName.slice(1);

        var offerObj = {
            "salary": self.data.salary && formatWage(self.data.salary),
            "position_name": self.selected_position.name,
            "position_code": self.selected_position.code,
            "position_id": self.selected_position.id,
            "compensation": self.data.compensation_rate,
            "offer_details": self.data.offer_details.offer_details.replace(/\$/g, currency),
            "brand_id": self.OBIdObj.brand_id,
            "job_type": self.data.job_type,
            "hours_per_week": self.data.hours_per_week,
            "days_per_week": self.data.days_per_week,
            "supervisor_title": self.data.supervisor_title,
            "last_name": lastName,
            "first_name": firstName,
            "employer_name": [user.data.user.first_name, user.data.user.last_name].join(" "),
            "offer_template_id": self.load_template?.template?.id || self.data.offer_template_id
        };

        if (self.schema_data?.length > 0) {
            self.schema_data.forEach(field => {
                if (self.data.hasOwnProperty(field.name) && self.data[field.name] !== undefined && self.data[field.name] !== null && self.data[field.name] !== '') {
                    offerObj[field.name] = self.data[field.name];
                    if (field.type === FIELD_TYPES.DATE) {
                        offerObj[field.name] = moment(offerObj[field.name]).locale("en").format(metaDatesFormat);
                    }
                }
            });
        }

        if (self.onBoardingBrandSettings.offer_type === 'RADISSON') {
            offerObj['country'] = self.data.radissonCountry && self.data.radissonCountry.name;
            offerObj['currency'] = self.data.radissonCurrency && self.data.radissonCurrency.code;
            offerObj['gross_net'] = self.data.radissonSalaryType && self.data.radissonSalaryType.name;

            var unitNameId = self.data.radissonUnitName && self.data.radissonUnitName.id;
            offerObj['unit_name'] = unitNameId ? self.data.radissonUnitName.name : self.data.other_radisson_unit_name;

        } else {
            offerObj['supervisor_name'] = self.data.supervisor_name;
        }

        if (self.data.start_date) {
            offerObj["start_date"] = moment(self.data.start_date).locale("en").format(metaDatesFormat);
        }

        if (self.data.first_pay_date) {
            offerObj["first_pay_date"] = moment(self.data.first_pay_date).locale("en").format(metaDatesFormat);
        }

        if (self.data.expiry_date) {
            offerObj["expiry_date"] = moment(self.data.expiry_date).locale("en").format(metaDatesFormat);
        }

        return offerObj;
    };

    self.isPositionInputDisabled = function () {
        return ((!self.isEditOfferEnabled || isATREnabled()) || self.cannotChangeOfferPosition())
    };

    self.isJobTypeInputDisabled = function () {
        return ((self.atrEnabled && self.isOfferRestrictedFromAtrData) ||
            !self.isEditOfferEnabled || (isATREnabled() && self.epsAtrEnabled && self.data.atr))
    };

    self.isPerHourInputDisabled = function () {
        return (self.atrEnabled && self.isOfferRestrictedFromAtrData) ||
            !self.isEditOfferEnabled || (self.atrEnabled && self.epsAtrEnabled && self.data.atr);
    };

    self.isWorkHoursInputDisabled = function () {
        var selectedATR = getATRById(self.data.atr);
        return (!self.isEditOfferEnabled || (isATREnabled() && self.epsAtrEnabled && selectedATR && selectedATR.contract_type_id == 'C'))
    };

    self.isWorkDaysInputDisabled = function () {
        var selectedATR = getATRById(self.data.atr);
        return (!self.isEditOfferEnabled || (isATREnabled() && self.epsAtrEnabled && selectedATR && selectedATR.contract_type_id == 'C'))
    };

    self.redirectToCoreHR = function () {
        var routeParams = {
            user_id: self.data.candidate.team_user_id,
            brand_id: self.OBIdObj.coreHREmployeeDetails.financial_unit_brand_id ,
        };

        var coreHrProfileURL = $state.href('appLayout.harriSH.core-hr.profile', routeParams);
        window.open(coreHrProfileURL, '_blank');
    }
};
